// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root___in1w","question":"Question_question__18TSJ","description":"Question_description__3_PDW"};